module.exports = __webpack_public_path__ + "static/media/nft5.4a14ba9b.jpg";